var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css, getModifier } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import styles from '../../@patternfly/patternfly-next/components/Alert/alert.css.js';
import accessibleStyles from '../../@patternfly/patternfly-next/utilities/Accessibility/accessibility.css.js';
import AlertIcon from './AlertIcon';
import AlertBody from './AlertBody';
import AlertAction from './AlertAction';
import { capitalize } from '../../internal/util';

export var AlertVariant = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  info: 'info'
};

var propTypes = {
  /** Adds Alert variant styles */
  variant: PropTypes.oneOf(Object.values(AlertVariant)).isRequired,
  /** Action button to put in the Alert */
  action: PropTypes.node,
  /** Title of the Alert */
  title: PropTypes.string,
  /** content rendered inside the Alert */
  children: PropTypes.node,
  /** additional classes added to the Alert */
  className: PropTypes.string,
  /** Adds accessible text to the Alert */
  'aria-label': PropTypes.string
};

var defaultProps = {
  'aria-label': undefined,
  action: null,
  title: '',
  children: '',
  className: ''
};

var getDefaultAriaLabel = function getDefaultAriaLabel(variant) {
  return capitalize(AlertVariant[variant]) + ' Notification';
};

var Alert = function Alert(_ref) {
  var variant = _ref.variant,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === undefined ? getDefaultAriaLabel(variant) : _ref$ariaLabel,
      action = _ref.action,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['variant', 'aria-label', 'action', 'title', 'children', 'className']);

  var readerTitle = React.createElement(
    React.Fragment,
    null,
    React.createElement(
      'span',
      { className: css(accessibleStyles.srOnly) },
      capitalize(AlertVariant[variant]),
      ': '
    ),
    title
  );

  var customClassName = css(styles.alert, getModifier(styles, variant, styles.modifiers.info), className);

  return React.createElement(
    'div',
    _extends({}, props, { className: customClassName, 'aria-label': ariaLabel }),
    React.createElement(AlertIcon, { variant: variant }),
    React.createElement(
      AlertBody,
      { title: readerTitle },
      children
    ),
    action && React.createElement(
      AlertAction,
      null,
      action
    )
  );
};

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

export default Alert;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Alert/Alert.js
// module id = 206
// module chunks = 0